/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import { useAuth } from '@/commons/auth';
import FormUbahDosenKelas from '../components/FormUbahDosenKelas'

import getDosenKelasData from '../services/getDosenKelasData'
import getDosen from '../services/getDosen'
const UbahDosenKelasPage = props => {
const { id, kelasId } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	ubahDosenKelas: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [dosenKelasData, setDosenKelasData] = useState()
const [dosen, setDosen] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, ubahDosenKelas: true}))
		const { data: dosenKelasDataResponse } = await getDosenKelasData({ id  })
		const { data: dosenResponse } = await getDosen({ id  })

	    setDosenKelasData(dosenKelasDataResponse.data)
	    setDosen(dosenResponse.data)


	    setIsLoading(prev => ({...prev, ubahDosenKelas: false}))
    }
	if (checkPermission("UpdateKelasDosen")) { 
		fetch()
	}
  }, [])

	
	useEffect(() => {
		setTitle("Ubah Dosen Kelas Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kelas/${kelasId}
			  	`}>
			  		<Button id="_ryqXkC55EfCJ1YDat3KRPQ" className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("UpdateKelasDosen") && ( 
	<Layouts.FormContainerLayout
		singularName={"Dosen"}
		isLoading={isLoading.ubahDosenKelas}
	>
		{dosenKelasData && dosen ? 
		(<>
		 <FormUbahDosenKelas
			{...{ 
				dosenKelasData
, 				dosen
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default UbahDosenKelasPage

